var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"a-crest",class:[_vm.crestClass, { 'a-crest--haslabel': _vm.label }]},[_vm._v(" "+_vm._s(_vm.content)+" "),(_vm.label)?_c('span',{staticClass:"a-crest__label"},[_vm._v(_vm._s(_vm.label))]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }